module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.routePath != '/photowall'),
      expression: "routePath!='/photowall'"
    }],
    staticClass: "header"
  }, [_c('ul', {
    staticClass: "headerUl fwb"
  }, [_c('img', {
    staticClass: "backimgs",
    attrs: {
      "src": require("../../assets/images/c28.png")
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "homeimgs",
    attrs: {
      "src": require("../../assets/images/k10.png")
    },
    on: {
      "click": function($event) {
        return _vm.goHome()
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/images/logo3.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "headerTab fwc"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/c19.png")
    },
    on: {
      "click": function($event) {
        return _vm.headerTab()
      }
    }
  })]), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.headerTabState),
      expression: "headerTabState"
    }],
    staticClass: "htUl animated fadeInRight"
  }, _vm._l((_vm.pages), function(item, index) {
    return _c('router-link', {
      key: index,
      class: ['htLi', {
        htActive: _vm.tabIndex == index
      }],
      attrs: {
        "index": index,
        "to": {
          name: item.path,
          query: {}
        },
        "tag": "li",
        "replace": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goChild2(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "headerList fwc"
  }, [_vm._l((_vm.pages), function(item, index) {
    return _c('router-link', {
      key: index,
      class: ['headerLi fhc', {
        headerActive: _vm.tabIndex == index
      }],
      attrs: {
        "index": index,
        "to": {
          name: item.path,
          query: {}
        },
        "tag": "li",
        "replace": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goChild(index)
        }
      }
    }, [_c('p', {
      staticClass: "p1"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "p2"
    }, [_vm._v(_vm._s(item.en))])])
  }), _vm._v(" "), _vm._l((_vm.server), function(item, index) {
    return _c('a', {
      key: index,
      class: ['headerLi fhc'],
      attrs: {
        "index": index,
        "href": "https://jsbingo.cn/pavilion/index1.html",
        "tag": "li",
        "replace": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goChild3(index)
        }
      }
    }, [_c('p', {
      staticClass: "p1"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "p2"
    }, [_vm._v(_vm._s(item.en))])])
  }), _vm._v(" "), _vm._l((_vm.aboutus), function(item, index) {
    return _c('router-link', {
      key: index,
      class: ['headerLi fhc', {
        headerActive: _vm.tabIndex3 == index
      }],
      attrs: {
        "index": index,
        "to": {
          name: item.path,
          query: {}
        },
        "tag": "li",
        "replace": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.goChild3(index)
        }
      }
    }, [_c('p', {
      staticClass: "p1"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('p', {
      staticClass: "p2"
    }, [_vm._v(_vm._s(item.en))])])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-730b9cc8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/Header.vue
// module id = 231
// module chunks = 10